module.exports = __webpack_public_path__ + "media/images/logos/washington_post-99024e4f0261e6a230dcd4c0b2c4adbb.svg";